// Self-contained data for the John Paul Silva real-estate concept website.
export const AGENT = {
  "slug": "john-paul-silva-real-estate-concept",
  "name": "John Paul Silva",
  "shortName": "John Paul",
  "role": "Real Estate Broker & Property Management Professional",
  "location": "Makati, BGC, Taguig & premium Metro Manila villages",
  "theme": "residence",
  "media": {
    "hero": {
      "src": "/realestate/john-paul-silva/474639943-488586294275797-1895976805545043432-n.webp",
      "thumbnail": "/realestate/john-paul-silva/474639943-488586294275797-1895976805545043432-n-720.webp",
      "alt": "Open living and dining room in a Metro Manila residence",
      "label": "A home that works in every detail",
      "type": "property"
    },
    "profile": {
      "src": "/realestate/john-paul-silva/profile.webp",
      "thumbnail": "/realestate/john-paul-silva/profile-720.webp",
      "alt": "Professional portrait of John Paul Silva",
      "label": "John Paul Silva",
      "type": "portrait"
    },
    "gallery": [
      {
        "src": "/realestate/john-paul-silva/471152585-467707553030338-3101565949290619591-n.webp",
        "thumbnail": "/realestate/john-paul-silva/471152585-467707553030338-3101565949290619591-n-720.webp",
        "alt": "High-rise residence illuminated at night",
        "label": "Metro Manila residences",
        "type": "property"
      },
      {
        "src": "/realestate/john-paul-silva/471185379-467131619754598-839289234422966671-n.webp",
        "thumbnail": "/realestate/john-paul-silva/471185379-467131619754598-839289234422966671-n-720.webp",
        "alt": "Contemporary detached house exterior",
        "label": "Homes beyond the condominium market",
        "type": "property"
      },
      {
        "src": "/realestate/john-paul-silva/471191608-467152566419170-2168286529979390791-n.webp",
        "thumbnail": "/realestate/john-paul-silva/471191608-467152566419170-2168286529979390791-n-720.webp",
        "alt": "Golf course and city skyline view",
        "label": "Premium village surroundings",
        "type": "property"
      },
      {
        "src": "/realestate/john-paul-silva/471192532-467134166421010-4043473956713246069-n.webp",
        "thumbnail": "/realestate/john-paul-silva/471192532-467134166421010-4043473956713246069-n-720.webp",
        "alt": "Furnished residential bedroom",
        "label": "Comfort considered room by room",
        "type": "property"
      },
      {
        "src": "/realestate/john-paul-silva/471303813-467152753085818-7564345956435886989-n.webp",
        "thumbnail": "/realestate/john-paul-silva/471303813-467152753085818-7564345956435886989-n-720.webp",
        "alt": "Elevated view across Metro Manila",
        "label": "Location and outlook",
        "type": "property"
      },
      {
        "src": "/realestate/john-paul-silva/471377700-467152939752466-5462826811503499827-n.webp",
        "thumbnail": "/realestate/john-paul-silva/471377700-467152939752466-5462826811503499827-n-720.webp",
        "alt": "Residential swimming pool",
        "label": "Amenities that support daily life",
        "type": "property"
      },
      {
        "src": "/realestate/john-paul-silva/471442789-467738016360625-170311961467307109-n.webp",
        "thumbnail": "/realestate/john-paul-silva/471442789-467738016360625-170311961467307109-n-720.webp",
        "alt": "Large house exterior with landscaped frontage",
        "label": "Larger family homes",
        "type": "property"
      },
      {
        "src": "/realestate/john-paul-silva/472816759-480644255070001-1820346311620220504-n.webp",
        "thumbnail": "/realestate/john-paul-silva/472816759-480644255070001-1820346311620220504-n-720.webp",
        "alt": "Branded townhouse property marketing card",
        "label": "A sample of public property marketing",
        "type": "listing"
      },
      {
        "src": "/realestate/john-paul-silva/472843095-480654095069017-6351160325758563543-n.webp",
        "thumbnail": "/realestate/john-paul-silva/472843095-480654095069017-6351160325758563543-n-720.webp",
        "alt": "John Paul Silva professional contact card",
        "label": "Broker and property-management support",
        "type": "brand"
      },
      {
        "src": "/realestate/john-paul-silva/472846491-480645668403193-1147895910888155481-n.webp",
        "thumbnail": "/realestate/john-paul-silva/472846491-480645668403193-1147895910888155481-n-720.webp",
        "alt": "Modern residential tower exterior",
        "label": "Condominium opportunities",
        "type": "property"
      },
      {
        "src": "/realestate/john-paul-silva/472938899-480641968403563-5903482663312996442-n.webp",
        "thumbnail": "/realestate/john-paul-silva/472938899-480641968403563-5903482663312996442-n-720.webp",
        "alt": "Ortigas Land Empires property graphic",
        "label": "Development marketing experience",
        "type": "listing"
      },
      {
        "src": "/realestate/john-paul-silva/474395371-488587414275685-7187850272035717922-n.webp",
        "thumbnail": "/realestate/john-paul-silva/474395371-488587414275685-7187850272035717922-n-720.webp",
        "alt": "Metro Manila skyline and transport corridor",
        "label": "Connected city locations",
        "type": "property"
      },
      {
        "src": "/realestate/john-paul-silva/474584942-488576804276746-3913645069674628957-n.webp",
        "thumbnail": "/realestate/john-paul-silva/474584942-488576804276746-3913645069674628957-n-720.webp",
        "alt": "Bright furnished bedroom",
        "label": "Ready-to-live interiors",
        "type": "property"
      },
      {
        "src": "/realestate/john-paul-silva/banner.webp",
        "thumbnail": "/realestate/john-paul-silva/banner-720.webp",
        "alt": "John Paul Silva property-services banner",
        "label": "Metro Manila property guidance",
        "type": "brand"
      },
      {
        "src": "/realestate/john-paul-silva/474661653-488587267609033-3765384248703801439-n.webp",
        "thumbnail": "/realestate/john-paul-silva/474661653-488587267609033-3765384248703801439-n-720.webp",
        "alt": "Second view of a contemporary living space",
        "label": "Layouts viewed from every angle",
        "type": "property"
      },
      {
        "src": "/realestate/john-paul-silva/banner-2.webp",
        "thumbnail": "/realestate/john-paul-silva/banner-2-720.webp",
        "alt": "John Paul Silva skyline brand banner",
        "label": "Property solutions across Metro Manila",
        "type": "brand"
      },
      {
        "src": "/realestate/john-paul-silva/profile-2.webp",
        "thumbnail": "/realestate/john-paul-silva/profile-2-720.webp",
        "alt": "John Paul Silva speaking at a professional event",
        "label": "Experienced, communicative support",
        "type": "portrait"
      }
    ]
  },
  "accent": "#A28A5B",
  "ink": "#17352D",
  "paper": "#F2F0E9",
  "eyebrow": "Metro Manila homes · leasing · property care",
  "headline": "From the first shortlist to the details that make a home work.",
  "intro": "Detailed, communicative real-estate support for local and overseas clients navigating premium Metro Manila rentals, houses and property-management needs.",
  "promise": "Professional guidance that continues beyond the contract.",
  "proof": [
    "5 Rentpad reviews",
    "5 five-star ratings",
    "Rentpad member since 2016",
    "Freelance Metro Manila broker"
  ],
  "audiences": [
    "Overseas clients returning home",
    "BGC & Makati renters",
    "Premium-home tenants",
    "Owners needing property support"
  ],
  "services": [
    {
      "title": "Condominium leasing",
      "text": "Public listings across BGC, Makati, Rockwell, Arca South and other major Metro Manila residential districts."
    },
    {
      "title": "Houses & larger homes",
      "text": "Experience represented in listings for Bacoor, San Lorenzo Village, Dasmariñas Village and Ayala Alabang."
    },
    {
      "title": "Remote search support",
      "text": "Efficient viewing and decision coordination for clients preparing a move while still overseas."
    },
    {
      "title": "Property management details",
      "text": "Hands-on attention to documentation, move-in requirements and practical setup after leasing."
    }
  ],
  "process": [
    "Clarify the move, property and documentation needs",
    "Prepare suitable homes and an efficient viewing plan",
    "Guide negotiation and lease requirements",
    "Help complete the practical transition into the home"
  ],
  "about": "John Paul describes his work as simplifying complex Philippine realty processes through detailed advice and strong local knowledge. His public listings span premium condominiums and larger homes, while reviewers repeatedly mention communication, fast execution, documentation support and help that continued into move-in.",
  "contact": {},
  "profiles": [
    {
      "label": "LinkedIn",
      "href": "https://ph.linkedin.com/in/brokerjpsilva",
      "imageSource": true
    },
    {
      "label": "Rentpad profile",
      "href": "https://rentpad.com.ph/user/john-paul-silva/24b8c10465",
      "imageSource": true
    }
  ],
  "websiteAssessment": "Highest-priority website gap: no dedicated business website surfaced; clients currently have to piece together John Paul’s professional story from LinkedIn and marketplace listings.",
  "reviewRating": 5,
  "reviewCount": 5,
  "reviews": [
    {
      "author": "MJ Sudoy",
      "stars": 5,
      "summary": "Says John Paul found a home within days, supported the whole move and even helped arrange Wi-Fi afterward.",
      "source": "https://rentpad.com.ph/user/john-paul-silva/24b8c10465"
    },
    {
      "author": "Alexis Cruz",
      "stars": 5,
      "summary": "Reports securing a home quickly while coordinating from overseas and praises his willingness to go beyond the expected role.",
      "source": "https://rentpad.com.ph/user/john-paul-silva/24b8c10465"
    },
    {
      "author": "Yana Kohli",
      "stars": 5,
      "summary": "Highlights detail, professionalism, knowledge and guidance that made the broker-client relationship feel personal.",
      "source": "https://rentpad.com.ph/user/john-paul-silva/24b8c10465"
    },
    {
      "author": "Emily Murphy",
      "stars": 5,
      "summary": "Describes attentive support, strong communication and professionalism throughout the leasing process.",
      "source": "https://rentpad.com.ph/user/john-paul-silva/24b8c10465"
    },
    {
      "author": "Sayoko Morita",
      "stars": 5,
      "summary": "Praises his politeness, helpfulness and communication during a home transition.",
      "source": "https://rentpad.com.ph/user/john-paul-silva/24b8c10465"
    }
  ],
  "sources": [
    {
      "label": "Rentpad",
      "href": "https://rentpad.com.ph/user/john-paul-silva/24b8c10465",
      "note": "Active inventory, rating and all five review records"
    },
    {
      "label": "LinkedIn",
      "href": "https://ph.linkedin.com/in/brokerjpsilva",
      "note": "Professional positioning, services, location and image-source profile"
    }
  ]
};
